import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* loadView3(action) {
  var payload = {
    action: "portal/dispatchEvent3",
    event: action.event,
    pageId: action.pageId,
    pageType: action.pageType,
    nodeId: action.nodeId,
    context: action.context,
    clientStatus: action.clientStatus,
  };
  yield put(serverRequest(payload));
}

export default loadView3;
